<div class="container">
  <div class="content">
    <div class="header">
      <h1 class="title" translate>USER_PROFILE.TITLE</h1>
      <p class="subtitle" translate>USER_PROFILE.SUBTITLE</p>
    </div>
    <form [formGroup]="profileForm" (ngSubmit)="setUserData()">
      <div class="form-field-wrapper">
        <p>
          <mat-form-field appearance="fill">
            <mat-label translate>USER_PROFILE.FIRSTNAME</mat-label>
            <input matInput type="text" formControlName="firstName" required />
            @if ((firstName?.dirty || firstName?.touched) && firstName?.errors?.required) {
              <mat-error translate>
                USER_PROFILE.ERROR_FIRSTNAME
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="fill">
            <mat-label translate>USER_PROFILE.LASTNAME</mat-label>
            <input matInput type="text" formControlName="lastName" required />
            @if ((lastName?.dirty || lastName?.touched) && lastName?.errors?.required) {
              <mat-error translate>
                USER_PROFILE.ERROR_LASTNAME
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p>
          <button mat-button type="button" (click)="openLanguageDialog()">
            <mat-icon svgIcon="language_v2" class="me-2"></mat-icon>
            <span>{{languageMapping[language?.value]}}</span>
          </button>
        </p>
      </div>
      <div class="actions">
        <button type="button" mat-stroked-button (click)="cancel()">
          <span translate>USER_PROFILE.CANCEL</span>
        </button>
        <button type="submit" [disabled]="profileForm.invalid" mat-raised-button color="primary">
          <span translate>USER_PROFILE.SUBMIT</span>
        </button>
      </div>
    </form>

    <div class="onboarding">
      <div class="header">
        <h2 class="title" translate>ONBOARDING.ONBOARDING</h2>
        <p class="subtitle" translate>ONBOARDING.REVIEW</p>
      </div>

      <p class="onboarding-button">
        <button mat-raised-button color="primary" (click)="openOnboarding()">
          <span translate>ONBOARDING.START_TOUR</span>
        </button>
      </p>
    </div>
  </div>
</div>
